import type { FC } from 'react';

import type { ClassStyleProps } from '../../../../types/ClassStyleProps';

export const KeyIcon: FC<ClassStyleProps> = ({ className, style }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M 11.25 3 C 9.179688 3 7.5 4.679688 7.5 6.75 C 7.5 7.128906 7.554688 7.496094 7.660156 7.839844 C 7.742188 8.105469 7.667969 8.390625 7.472656 8.585938 L 3 13.0625 L 3 15 L 4.5 15 L 4.5 14.25 C 4.5 13.835938 4.835938 13.5 5.25 13.5 L 6 13.5 L 6 12.75 C 6 12.335938 6.335938 12 6.75 12 L 7.9375 12 L 9.414062 10.527344 C 9.609375 10.332031 9.894531 10.257812 10.160156 10.339844 C 10.503906 10.445312 10.871094 10.5 11.25 10.5 C 13.320312 10.5 15 8.820312 15 6.75 C 15 4.679688 13.320312 3 11.25 3 Z M 6 15 L 6 15.75 C 6 16.164062 5.664062 16.5 5.25 16.5 L 3 16.5 C 2.171875 16.5 1.5 15.828125 1.5 15 L 1.5 13.0625 C 1.5 12.664062 1.65625 12.28125 1.9375 12 L 6.109375 7.828125 C 6.039062 7.480469 6 7.117188 6 6.75 C 6 3.851562 8.351562 1.5 11.25 1.5 C 14.148438 1.5 16.5 3.851562 16.5 6.75 C 16.5 9.648438 14.148438 12 11.25 12 C 10.882812 12 10.519531 11.960938 10.171875 11.890625 L 8.78125 13.28125 C 8.640625 13.421875 8.449219 13.5 8.25 13.5 L 7.5 13.5 L 7.5 14.25 C 7.5 14.664062 7.164062 15 6.75 15 Z M 10.5 5.25 C 10.5 4.835938 10.835938 4.5 11.25 4.5 C 12.492188 4.5 13.5 5.507812 13.5 6.75 C 13.5 7.164062 13.164062 7.5 12.75 7.5 C 12.335938 7.5 12 7.164062 12 6.75 C 12 6.335938 11.664062 6 11.25 6 C 10.835938 6 10.5 5.664062 10.5 5.25 Z M 10.5 5.25 "
        fill="currentColor"
      />
    </svg>
  );
};
